/**
 * Porté depuis apps/web/app/(shop)/a-propos/page.tsx (page statique, aucune
 * adaptation nécessaire au-delà de l'abandon de `generateMetadata`, hors
 * périmètre — cf. lot SEO/prérendu séparé).
 */
export function AProposPage() {
  return (
    <div className="container-vvs py-8 lg:py-12">
      <h1 className="font-display text-2xl font-bold text-navy sm:text-3xl">Qui sommes-nous</h1>
      <div className="mt-4 max-w-prose space-y-6 font-body text-sm leading-relaxed text-muted">
        <div>
          <h2 className="font-display text-base font-semibold text-ink">
            VVS — Vendez-Vous eShop, le marketplace généraliste ivoirien
          </h2>
          <p className="mt-1">
            VVS réunit sur une seule plateforme des univers que l&apos;on trouve d&apos;habitude
            éparpillés sur des boutiques séparées&nbsp;: bijoux &amp; montres, mode &amp;
            accessoires, beauté &amp; parfums, électronique &amp; high-tech, maison &amp; déco,
            enfants &amp; bébé. L&apos;objectif est simple&nbsp;: permettre à toute personne en
            Côte d&apos;Ivoire de trouver ce dont elle a besoin sans multiplier les sites, les
            livreurs et les modes de paiement.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Des vendeurs vérifiés</h2>
          <p className="mt-1">
            Les articles proposés sur VVS proviennent de vendeurs référencés sur la plateforme,
            pas d&apos;annonces publiées librement par n&apos;importe qui. Cette sélection vise à
            offrir une expérience d&apos;achat cohérente&nbsp;: des fiches produits claires, des
            prix affichés en toute transparence et un même parcours de commande, quel que soit le
            rayon parcouru.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Un fonctionnement pensé pour le marché local</h2>
          <p className="mt-1">
            Plutôt que d&apos;importer un parcours d&apos;achat pensé pour un autre pays, VVS a
            choisi dès le départ les habitudes déjà répandues ici&nbsp;: paiement à la livraison
            ou par mobile money, livraison à Abidjan et dans les grandes villes de Côte
            d&apos;Ivoire, et une confirmation de commande par téléphone avant expédition. C&apos;est
            une étape simple qui évite les mauvaises surprises, pour l&apos;acheteur comme pour le
            vendeur.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">Notre ambition</h2>
          <p className="mt-1">
            VVS se construit progressivement, rayon après rayon et ville après ville, avec un
            principe constant&nbsp;: rester honnête sur ce que la plateforme propose réellement,
            plutôt que d&apos;annoncer des services qui ne sont pas encore disponibles.
          </p>
        </div>
      </div>
    </div>
  );
}
